export default __webpack_public_path__ + "次品追责.jpg";